import { createReducer, on } from '@ngrx/store';
import { Video } from '../model/video';
import { addVideoSuccess, deleteVideo, deleteVideoSuccess, loadVideos, loadVideosFailure, loadVideosSuccess, selectVideo } from '../action/video.actions';
export interface VideoState {
  video: Video[];
  selectedVideo: Video | null;
  error: string | null;
  loading: boolean;
}

const initialState: VideoState = {
  video: [],
  selectedVideo: null,
  error: null,
  loading: false
};

export const videoReducer = createReducer(
  initialState,

  // Load Videos
  on(loadVideosSuccess, (state, { video }) => ({
    ...state,
    video
  })),
  on(loadVideosFailure, (state, { error }) => ({
    ...state,
    error
  })),

  // Add Video
  // on(addVideoSuccess, (state, { video }) => ({
  //   ...state,
  //   video: [...state.video, video]
  // })),
  on(addVideoSuccess, (state, { video }) => {
    const existingIndex = state.video.findIndex(v => v.id === video.id);

    if (existingIndex !== -1) {
      // If the video exists, update it
      const updatedVideos = [...state.video];
      updatedVideos[existingIndex] = video; // Update existing video

      return {
        ...state,
        video: updatedVideos
      };
    } else {
      // If the video does not exist, add a new one
      return {
        ...state,
        video: [...state.video, video]
      };
    }
  }),

  // Update Video
  // on(updateVideoSuccess, (state, { video }) => ({
  //   ...state,
  //   videos: state.video.map(v => v.id === video.id ? video : v)
  // })),

  // Select Video
  on(selectVideo, (state, { videoId }) => ({
    ...state,
    selectedVideo: state.video.find(v => v.id === videoId) || null
  })),

  // delete video
  on(deleteVideoSuccess,(state,{id})=>({
    ...state,
    video:state.video.filter(video=>video.id !==id)

  })),
  on(loadVideos, (state) => ({ ...state, loading: true })), // Set loading true on API call
  on(loadVideosSuccess, (state, { video }) => ({
    ...state,
    video: video,
    loading: false  // Set loading false on API success
  })),
  on(loadVideosFailure, (state) => ({ ...state, loading: false })) // Also false on error

);
